export class OtherSubsidy {
	id?: number;
	descriptionAndPeriod?: string;
	governmental: boolean;
	subsidyAmount: number;
	subsidyAttachmentId?: number;
	subsidyOrganisation: string;

	constructor(obj: any = {}) {
		this.id = obj.id;
		this.descriptionAndPeriod = obj.descriptionAndPeriod;
		this.governmental = obj.governmental;
		this.subsidyAmount = obj.subsidyAmount;
		this.subsidyAttachmentId = obj.subsidyAttachmentId;
		this.subsidyOrganisation = obj.subsidyOrganisation;
	}
}
